import React from 'react';
import './WhatsappCTA.css';
import { FaWhatsapp } from 'react-icons/fa'; // Import the WhatsApp icon

const WhatsappCTA = () => {
  // Replace with your actual WhatsApp channel link
  const whatsappChannelLink = "https://whatsapp.com/channel/YOUR_CHANNEL_ID";

  return (
    <section className="whatsapp-cta-section">
      <div className="whatsapp-cta-container">
        <div className="section-header">
          <h2>Join the CRISHI WhatsApp channel</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Stay updated with daily trends, price insights, event news, and webinar alerts—covering grains, oilseeds, pulses, and spices markets.
        </p>
        <a href={whatsappChannelLink} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
          <FaWhatsapp />
          Follow WhatsApp channel
        </a>
      </div>
    </section>
  );
};

export default WhatsappCTA;